import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { resetScrollStates, setData, setIsFetching, setLastPage, setPageNum, setRerender } from '../../redux/Slices/scrollSlice'
import { useFetchDataByPathMutation } from '../../queries/dataTable'
import { ProgressSpinner } from 'primereact/progressspinner'

export default function ScrollContainer({ path, showLoading = true, optionalParam = {}, children }) {
    const fetchDataByPathMutation = useFetchDataByPathMutation()

    const { pageNum, params, lastPage, lastElement, isFetching, data, rerender } = useSelector(state => state.scroll)
    const dispatch = useDispatch();
    const initialRenderRef = useRef(1);

    const observer = useRef(
        new IntersectionObserver((entries) => {
            const first = entries[0];
            if (first.isIntersecting) {
                dispatch(setPageNum());
            }
        })
    );

    const refetch = async () => {
        if (path) {
            let _param = { ...params, ...optionalParam }

            if (window.location.pathname.includes("/gallery")) {
                _param = { ..._param, section: "MEDIA" }
            } else if (window.location.pathname.includes("/links")) {
                _param = { ..._param, section: "LINKS" }
            }

            const uniqueParams = Object.entries(_param).reduce((acc, [key, value]) => {
                acc[key] = value;
                return acc;
              }, {});

            await fetchDataByPathMutation.mutateAsync({
                path, pageNum, params: { ...uniqueParams, ...optionalParam }
            }, {
                onSuccess: (response) => {
                    dispatch(setLastPage(response?.pagination?.total_pages));
                    dispatch(setData(response.data))
                    dispatch(setRerender(false));
                }
            })
        }
    };

    useEffect(() => {
        if ((pageNum <= lastPage || lastPage == null)) {
            refetch();
        }
    }, [pageNum]);

    useEffect(() => {
        if (initialRenderRef.current === 1)
            initialRenderRef.current = 2;
        else {
            if (pageNum === 1)
                refetch()
            else
                dispatch(setPageNum(1));
        }
    }, [params]);

    useEffect(() => {

        if (initialRenderRef.current === 2)
            initialRenderRef.current = 3;
        else {
            if (rerender) {
                if (pageNum === 1)
                    refetch()
                else
                    dispatch(setPageNum(1));
            }
        }

    }, [rerender]);

    useEffect(() => {
        return () => {
            dispatch(resetScrollStates());
        }
    }, []);

    useEffect(() => {
        const currentElement = lastElement;
        const currentObserver = observer.current;

        if (currentElement) {
            currentObserver.observe(currentElement);
        }

        return () => {
            if (currentElement) {
                currentObserver.unobserve(currentElement);
            }
        };
    }, [lastElement]);

    useEffect(() => {
        dispatch(setIsFetching(fetchDataByPathMutation.isLoading))
    }, [fetchDataByPathMutation.isLoading]);

    return (
        <>
            {
                isFetching && data?.length === 0 && showLoading ?
                    <div className="my-3">
                        <ProgressSpinner
                            className='h-[50px] w-[50px] flex justify-center items-center'
                            strokeWidth="3"
                            fill="var(--surface-ground)"
                            animationDuration="30s" />
                    </div>
                    :
                    <></>
            }
            {children}
        </>
    )
}
